import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { border, rem } from 'polished';
import { __, __r } from 'react-i18n';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { SvgIcon, IconType } from '../../General/SvgIcon';
import { TextP, TextSpan } from '../../../Defaults/Text';

export interface Props {
  theme: any;
  borderBottom?: boolean;
}

function WholePackagesOnly({ theme, borderBottom }: Props) {
  return (
    <Wrapper>
      <InfoRowWrapper borderBottom={false} isSecondRow={false}>
        <SvgIcon
          fill={theme.colors.stockCountWarning}
          width={24}
          height={24}
          icon={IconType.success}
          alt="info"
          title="info"
          marginRight={16}
        />
        <Text>
          {__('Iba na celé balenia alebo zostatok už rozbaleného balenia')}{' '}
        </Text>
      </InfoRowWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  max-width: 100%;
  display: flex;
  flex-flow: column;

  @media only screen and (max-width: 480px) {
    max-width: 327px;
  }
`;

const InfoRowWrapper = styled(FlexRowCenterVertical)<{
  borderBottom?: boolean;
  isSecondRow?: boolean;
}>`
  text-decoration: none;
  margin-bottom: 0;
  max-width: 100%;
  border-radius: ${rem(2)};
  padding: ${rem(12)} ${rem(16)};
  background: ${({ theme }) => theme.colors.stockCountUnavailableBackground};
  align-items: flex-start;
  border-bottom: ${({ theme, borderBottom }) =>
    borderBottom ? theme.borders.primary : 'none'};

  ${({ theme }) => theme.mediab.m810`
     margin-top: ${rem(6)};
  `}
`;

const Text = styled(TextSpan)<{ additionalInfo?: boolean }>`
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.font.secondaryLight};
  color: ${({ theme }) => theme.colors.stockCountWarning};
  line-height: ${rem(22)};
  font-weight: 400;
  max-width: 90%;

  ${({ theme }) => theme.mediab.m810`
     font-size: ${rem(13)};
     line-height: ${rem(21)};
  `}
`;

const withThemeInfoText: any = withTheme(WholePackagesOnly);
export { withThemeInfoText as WholePackagesOnly };
